import type { Role } from "../types/person";

/**
 * Shared types and helpers used by both the user-import (full profile,
 * Users page) and the attendee-import (email-only, Attendees page) flows.
 */

/** Roles an organizer is allowed to assign via the import flow. */
export const ASSIGNABLE_ROLES: readonly Role[] = [
  "companion",
  "invitee",
  "internal",
  "organizer",
] as const;

/** Default role applied when an import row leaves the role column blank. */
export const DEFAULT_IMPORT_ROLE: Role = "invitee";

/**
 * Lifecycle of an import row, surfaced in the preview table and the final
 * result summary. Both user-import and attendee-import use the same set so
 * a shared result-table component can render them uniformly.
 */
export type RowStatus =
  | "pending"
  | "invalid"
  | "submitting"
  | "success"
  | "duplicate"
  | "failed";

/** Basic email shape check shared across import paths. */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Trim a cell value; collapse undefined/null to empty string. */
export function normalize(value: string | null | undefined): string {
  return (value ?? "").trim();
}

/** Lowercase + trim — used as a key for dedup. */
export function normalizeEmailKey(value: string | null | undefined): string {
  return normalize(value).toLowerCase();
}
